import { SmallDonutCard } from "~/components/SmallDonut";
import { useMetrics } from "~/hooks";
import { Metrics } from "~/lib/arrow";
import { VulnerabilitiesIcon } from "~/icons";
import { DonutChartCardProps } from "~/pages/space/home-dashboard/components/types";

export function HomeDashboardVulnerabilitiesDonutChart({
  scope,
}: DonutChartCardProps) {
  const { vulnerableAssetsSeverity, isLoading } = useMetrics({
    entityMrn: scope?.mrn || "",
    metricMrns: [Metrics.VulnerableAssetsSeverity],
  });

  return (
    <SmallDonutCard
      to={`/space/inventory/exposed-assets?${scope?.params?.toString()}`}
      data-testid="vulnerable-assets-donut-chart"
      loading={isLoading}
      data={vulnerableAssetsSeverity}
      title="Exposed Assets"
      icon={<VulnerabilitiesIcon />}
    />
  );
}
